'use client'

import Image from 'next/image'

/**
 * Desktop left-rail menu only: avatar with tier-colored ring.
 * Uses inline styles only (no donate-profile CSS, no Tailwind ring/shadow) so nothing draws a second circle.
 */

const TIER_BORDER: Record<string, string> = {
  tier1: '#cd7f32',
  tier2: '#c0c0c0',
  tier3: '#3b82f6',
  tier4: '#10b981',
  tier5: '#06b6d4',
  tier6: '#8b5cf6',
  tier7: '#f97316',
  tier8: '#eab308',
  tier9: '#ec4899',
  tier10: '#ef4444',
}

type Props = {
  src: string
  alt: string
  /** Collapsed rail = 32, expanded user row = 36 */
  size: 32 | 36
  donorTier: string
}

export default function SidebarMenuAvatar({ src, alt, size, donorTier }: Props) {
  const key = String(donorTier ?? 'none').toLowerCase()
  const tierColor = key === 'none' ? null : (TIER_BORDER[key] ?? '#71717a')
  const border = tierColor ?? 'rgba(113, 113, 122, 0.75)'
  const inner = Math.max(8, size - 6)

  return (
    <span
      className="shrink-0"
      style={{
        display: 'inline-flex',
        width: size,
        height: size,
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
        verticalAlign: 'middle',
      }}
    >
      <span
        style={{
          display: 'flex',
          width: size,
          height: size,
          boxSizing: 'border-box',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 9999,
          overflow: 'hidden',
          backgroundColor: 'rgba(39, 39, 42, 0.9)',
          border: `1px solid ${border}`,
        }}
      >
        <Image
          src={src}
          alt={alt}
          width={inner}
          height={inner}
          unoptimized
          style={{
            width: inner,
            height: inner,
            display: 'block',
            borderRadius: 9999,
            objectFit: 'cover',
            margin: 0,
            padding: 0,
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
          }}
          draggable={false}
          decoding="async"
        />
      </span>
    </span>
  )
}
